import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp';
import serviceIconApps from '../../assets/images/service-icon-apps.webp';
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp';
import serviceIconWebsite from '../../assets/images/service-icon-website.webp';
import ServicesPricingCTA from '../ServicesPricingCTA';

const serviceLinks = [
  {
    label: 'Web Development in Northwest Arkansas',
    description: 'Professional websites, online stores, and reliable hosting built for your business.',
    icon: serviceIconWebsite,
    path: '/services/websites',
  },
  {
    label: 'Mobile App Development in Northwest Arkansas',
    description: 'Custom mobile experiences that help you serve customers and streamline daily work.',
    icon: serviceIconApps,
    path: '/services/appdev',
  },
  {
    label: 'Cloud Consulting in Northwest Arkansas',
    description: 'Practical cloud, AI, and technology guidance designed around your goals and budget.',
    icon: serviceIconConsulting,
    path: '/services/consulting',
  },
  {
    label: '3D Printing in Northwest Arkansas',
    description: 'Custom parts, prototypes, gifts, and creative prints made locally from your idea.',
    icon: serviceIcon3dPrint,
    path: '/services/3dprints',
  },
];

const Services: React.FC = () => {
  return (
    <div className="services-container">
      <section className="services-intro">
        <h1>Technology Services for Northwest Arkansas</h1>
        <p>
          Hogcloud provides professional website development and cost-efficient hosting, custom
          mobile apps, experienced cloud development, AI agents and prompting,
          and custom 3D printing for Northwest Arkansas small businesses,
          creators, families, and local organizations.
        </p>
        <nav className="local-service-links" aria-label="Northwest Arkansas service pages">
          {serviceLinks.map((serviceLink) => (
            <Link key={serviceLink.path} to={serviceLink.path} aria-label={serviceLink.label}>
              <img src={serviceLink.icon} alt="" aria-hidden="true" />
              <span className="local-service-links__copy">
                <strong>{serviceLink.label}</strong>
                <span>{serviceLink.description}</span>
              </span>
            </Link>
          ))}
        </nav>
      </section>

      <ServicesPricingCTA />

    </div>
  );
};

export default Services;
